import { useSortable } from '@dnd-kit/sortable'

export const LevelPlayJigsawPiece = ({
  imageSrc,
  position,
  id,
  aspectRatio = 1,
  ...rest
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id,
      transition: {
        duration: 500, // milliseconds
        easing: 'cubic-bezier(1, 1, 0, 1)'
      }
    })

  const style = {
    aspectRatio: String(aspectRatio),
    ...(transform
      ? {
          transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
          transition
        }
      : {})
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      {...rest}
      className="overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm cursor-grab active:cursor-grabbing touch-none"
    >
      <img
        src={imageSrc}
        alt={`Peça ${position + 1} do quebra-cabeça`}
        className="block w-full h-full object-fill select-none pointer-events-none"
      />
    </div>
  )
}
